import { z } from 'zod';
import { packagePublicSchema } from './package.js';

export const paymentCreateRequestSchema = z.object({
  packageId: z.number().int().positive(),
  promoCode: z.string().trim().min(1).max(32).optional(),
});
export type PaymentCreateRequest = z.infer<typeof paymentCreateRequestSchema>;

export const paymentCreateResponseSchema = z.object({
  paymentUrl: z.string().url(),
  invoiceId: z.string(),
});
export type PaymentCreateResponse = z.infer<typeof paymentCreateResponseSchema>;

/** POST /promo/apply */
export const promoApplyRequestSchema = z.object({
  code: z.string().trim().min(1).max(32),
});
export type PromoApplyRequest = z.infer<typeof promoApplyRequestSchema>;

export const promoApplyResponseSchema = z.discriminatedUnion('kind', [
  z.object({
    kind: z.literal('discount'),
    packageId: z.number().int().positive(),
    finalPriceKzt: z.number().int().positive(),
    // The package the code applies to — may be hidden (promo tariff), so the
    // client renders its card from here, not from GET /packages.
    package: packagePublicSchema,
  }),
  z.object({
    kind: z.literal('turbo'),
    turboUntil: z.string(),
  }),
]);
export type PromoApplyResponse = z.infer<typeof promoApplyResponseSchema>;

/** GET /payments/result/:invoiceId — what the buyer got, for the success page. */
export const paymentResultResponseSchema = z.object({
  status: z.enum(['pending', 'paid', 'failed', 'cancelled']),
  kind: z.enum(['credits', 'turbo']).optional(),
  credits: z.number().int().positive().optional(),
  expiresAt: z.string().optional(),
  turboUntil: z.string().optional(),
});
export type PaymentResultResponse = z.infer<typeof paymentResultResponseSchema>;
